exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#model-tree[data-v-58af0161]{background-color:transparent}[data-v-58af0161] .el-loading-mask{height:calc(100% - 42px);background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
